// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".std--dropdown.v-select[data-v-50aa04ba] {\n  width: 250px !important;\n}\n.ctx-dropdown-label[data-v-50aa04ba] {\n  font-size: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
